import { render, staticRenderFns } from "./feedBackDetail.vue?vue&type=template&id=33c2f03a&scoped=true"
import script from "./feedBackDetail.vue?vue&type=script&lang=js"
export * from "./feedBackDetail.vue?vue&type=script&lang=js"
import style0 from "./feedBackDetail.vue?vue&type=style&index=0&id=33c2f03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2f03a",
  null
  
)

export default component.exports